import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { GatheringSpot } from '@outdoria/types';
import { fetcher } from '../utils';
import {
  ADMIN_GATHERING_SPOT_UPDATE,
  GATHERING_SPOT,
  GATHERING_SPOTS_ALL,
} from '../queryKeys';

export const useAdminUpdateGatheringSpot = (gathering_spot_id: string) => {
  const queryClient = useQueryClient();

  const mutationFn = async (
    gathering_spot: Omit<GatheringSpot, 'gathering_spot_id'>,
  ): Promise<void> => {
    const response = await fetcher(
      `/v2/admin/gathering_spots/${gathering_spot_id}`,
      {
        method: 'PUT',
        body: JSON.stringify(gathering_spot),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      },
    );

    if (response.status !== 204)
      throw new Error(
        (await response.json()).error ??
          'Could not update the gathering spot for some unforeseen reason!',
      );
    queryClient.invalidateQueries({ queryKey: GATHERING_SPOTS_ALL });
    queryClient.invalidateQueries({
      queryKey: GATHERING_SPOT,
      exact: false,
    });
  };

  const { mutate, error, status, isPending, isSuccess, isError } = useMutation({
    mutationKey: ADMIN_GATHERING_SPOT_UPDATE,
    mutationFn,
  });

  return { mutate, error, status, isPending, isSuccess, isError };
};
